import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

// components
import Navbar from "components/Navbars/AuthNavbar.js";
import FooterSmall from "components/Footers/FooterSmall.js";

// views
import Register from "views/auth/Register.js";
import AdminLogin from "components/Forms/AdminLogin";

export default function Auth() {
  return (
    <>
      {/* <Navbar transparent /> */}
      <main>
        <section className="relative w-full h-full py-10 min-h-screen">
          <div
            className="absolute top-0 w-full h-full bg-blueGray-800 bg-no-repeat bg-full"
            style={{
              backgroundImage:
                "url(" + require("assets/img/register_bg_2.png").default + ")",
            }}
          ></div>
          <Routes>
            {/* ✅ Using relative paths instead of absolute */}
            <Route path="login" element={<AdminLogin />} />
            <Route path="register" element={<Register />} />
            {/* Default /auth should redirect to /auth/login */}
            <Route index element={<Navigate to="login" replace />} />
          </Routes>
          {/* <FooterSmall absolute /> */}
        </section>
      </main>
    </>
  );
}
